
import { defineComponent, onMounted, ref, inject } from "vue";
import useBreakpoints from "@/services/Breakpoints";

export default defineComponent({
  setup() {
    const { height, type } = useBreakpoints();
    const emitter: any = inject("emitter");
    const dialog = ref(false);
    const formEmbedded = ref("");

    onMounted(async () => {
      emitter.on("openSurvey", (formData) => {
        formEmbedded.value = `${formData}?embedded=true`;
        dialog.value = true;
      });
    });
    return {
      dialog,
      formEmbedded,
      height,
      type,
    };
  },
});
